<header class="page-head" data-testid="broadcasts-call-section">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-phone"></i></span>
    <div>
      <h1 class="page-head__title">Broadcasts de Voz</h1>
      <p class="page-head__subtitle">Ligações em massa com um áudio gravado para uma lista, com tentativas para quem não atende.</p>
    </div>
  </div>
  <div class="page-head__actions">
    <a [routerLink]="['/broadcasts-call/new']" class="sf-btn sf-btn--primary sf-btn--pill sf-btn--icon-right" data-testid="btn-new-broadcast-call">
      Novo Broadcast de Voz <i class="fa fa-plus"></i>
    </a>
  </div>
</header>

<div class="m8v-filter-bar" data-testid="broadcasts-call-filter-bar">
  <div class="m8v-search grow">
    <i class="fa fa-search ic"></i>
    <input
      type="text"
      class="form-control"
      placeholder="Pesquisar pelo nome"
      [(ngModel)]="search"
      name="search"
      (keyup.enter)="searchSubmit()"
      data-testid="input-search"
    />
    <button type="button" class="go" (click)="searchSubmit()" title="Pesquisar" data-testid="btn-search">
      <i class="fa fa-chevron-right"></i>
    </button>
  </div>

  <div class="m8v-seg" data-testid="status-segments">
    <button
      type="button"
      *ngFor="let seg of segments"
      [class.on]="segment === seg.key"
      (click)="setSegment(seg.key)"
      [attr.data-testid]="'segment-' + seg.key"
    >
      {{ seg.label }}
    </button>
  </div>

  <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm clear" *ngIf="hasFilters" (click)="clearFilters()" data-testid="btn-clear-filters">
    <i class="fa fa-times"></i> Limpar filtros
  </button>
</div>

<app-skeleton *ngIf="loading" variant="table-row" [count]="6" [columns]="5"
  label="Carregando os disparos de voz" data-testid="broadcasts-call-loading"></app-skeleton>

<!-- Vazio -->
<div *ngIf="!loading && (!result?.data || result.data.length === 0)" class="m8v-empty" data-testid="broadcasts-call-empty">
  <i class="fa fa-phone ic"></i>
  <h3>Nenhum broadcast de voz encontrado</h3>
  <p *ngIf="!hasFilters">Grave ou envie um áudio em Ligações → Áudios e crie o primeiro broadcast.</p>
  <p *ngIf="hasFilters">Nenhum bate com a busca ou o filtro.</p>
  <div class="acts">
    <button *ngIf="hasFilters" type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="clearFilters()" data-testid="btn-empty-clear-filters">
      <i class="fa fa-times"></i> Limpar filtros
    </button>
    <a *ngIf="!hasFilters" [routerLink]="['/broadcasts-call/new']" class="sf-btn sf-btn--primary sf-btn--sm" data-testid="btn-empty-new">
      <i class="fa fa-plus"></i> Novo Broadcast de Voz
    </a>
  </div>
</div>

<ng-container *ngIf="!loading && result?.data?.length > 0">

  <!-- Desktop: tabela -->
  <div class="card m8v-desktop-only">
    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th style="width: 25%;">Nome</th>
            <th style="width: 10%;">Status</th>
            <th style="width: 20%;">Data Agendada</th>
            <th style="width: 10%; text-align: center;">Enviados</th>
            <th style="width: 10%; text-align: center;">Atendidos</th>
            <th style="width: 15%; text-align: center;">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let bc of result.data">
            <!-- Nome -->
            <td>
              <a class="m8v-name-link" [routerLink]="['/broadcasts-call/view', bc.id]">{{ bc.name }}</a>
              <div class="m8v-meta-line" *ngIf="bc.leadList">
                <span class="m8v-meta-chip"><i class="fa fa-list-ul ic"></i> {{ bc.leadList.name }}</span>
              </div>
            </td>

            <!-- Status -->
            <td>
              <span class="m8v-status-pill m8v-status-pill--sm" [ngClass]="'m8v-status-pill--' + statusTone(bc)" data-testid="broadcast-call-status">
                <span class="dot"></span>{{ statusView(bc).label }}
              </span>
            </td>

            <!-- Data Agendada -->
            <td>
              {{ bc.scheduled_date ? (brasiliaIso(bc.scheduled_date) | date:'dd/MM/yyyy HH:mm' : '-0300') : 'Imediato' }}
            </td>

            <!-- Enviados -->
            <td style="text-align: center;">
              {{ bc.total_sent ?? 0 }}
            </td>

            <!-- Atendidos -->
            <td style="text-align: center;">
              {{ bc.total_answered ?? 0 }}
              <span class="m8v-meta-chip" *ngIf="answeredPercent(bc) != null">{{ answeredPercent(bc) }}%</span>
            </td>

            <!-- Ações -->
            <td style="text-align: center;">
              <a
                class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm me-1"
                [routerLink]="['/broadcasts-call/view', bc.id]"
                title="Visualizar"
              >
                <i class="fa fa-search"></i>
              </a>
              <a
                class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm me-1"
                [routerLink]="['/broadcasts-call/edit', bc.id]"
                title="Editar"
              >
                <i class="fa fa-edit"></i>
              </a>
              <button
                *ngIf="canPause(bc)"
                class="sf-btn sf-btn--sm sf-btn--secondary me-1"
                (click)="pauseBroadcast(bc)"
                title="Pausar"
              >
                <i class="fa fa-pause"></i>
              </button>
              <button
                *ngIf="canResume(bc)"
                class="sf-btn sf-btn--sm sf-btn--secondary me-1"
                (click)="resumeBroadcast(bc)"
                title="Retomar"
              >
                <i class="fa fa-play"></i>
              </button>
              <button
                *ngIf="canCancel(bc)"
                class="sf-btn sf-btn--sm sf-btn--danger"
                (click)="confirmCancel(bc)"
                title="Cancelar"
              >
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Celular: cartões -->
  <div class="m8v-row-list m8v-mobile-only">
    <div
      class="m8v-row-card"
      *ngFor="let bc of result.data"
      [class.tone-ok]="statusTone(bc) === 'ok'"
      [class.tone-warn]="statusTone(bc) === 'warn'"
      [class.tone-cool]="statusTone(bc) === 'cool'"
      [class.tone-danger]="statusTone(bc) === 'danger'"
      [class.is-cancelled]="bc.status?.status === 'Cancelado'"
      data-testid="broadcast-call-card"
    >
      <span class="m8v-row-avatar"><i class="fa fa-phone"></i></span>
      <div class="info">
        <div class="name">
          <a class="m8v-name-link" [routerLink]="['/broadcasts-call/view', bc.id]">{{ bc.name }}</a>
          <span class="m8v-status-pill m8v-status-pill--sm" [ngClass]="'m8v-status-pill--' + statusTone(bc)">
            <span class="dot"></span>{{ statusView(bc).label }}
          </span>
        </div>
        <div class="m8v-meta-line">
          <span class="m8v-meta-chip" *ngIf="bc.leadList"><i class="fa fa-list-ul ic"></i> {{ bc.leadList.name }}</span>
          <span class="m8v-meta-chip">
            {{ bc.scheduled_date ? (brasiliaIso(bc.scheduled_date) | date:'dd/MM/yyyy HH:mm' : '-0300') : 'Imediato' }}
          </span>
        </div>
        <div class="stats">
          <div class="stat">
            <b>{{ bc.total_sent ?? 0 }}</b>
            <span>Enviados</span>
          </div>
          <div class="stat" [class.ok]="answeredPercent(bc) != null">
            <b>{{ bc.total_answered ?? 0 }}{{ answeredPercent(bc) != null ? ' (' + answeredPercent(bc) + '%)' : '' }}</b>
            <span>Atendidos</span>
          </div>
        </div>
      </div>
      <div class="icon-group">
        <a class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" [routerLink]="['/broadcasts-call/view', bc.id]" title="Visualizar">
          <i class="fa fa-search"></i>
        </a>
        <a class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" [routerLink]="['/broadcasts-call/edit', bc.id]" title="Editar">
          <i class="fa fa-edit"></i>
        </a>
        <button *ngIf="canPause(bc)" class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm" (click)="pauseBroadcast(bc)" title="Pausar">
          <i class="fa fa-pause"></i>
        </button>
        <button *ngIf="canResume(bc)" class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm" (click)="resumeBroadcast(bc)" title="Retomar">
          <i class="fa fa-play"></i>
        </button>
        <button *ngIf="canCancel(bc)" class="sf-btn sf-btn--danger sf-btn--icon sf-btn--sm" (click)="confirmCancel(bc)" title="Cancelar">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</ng-container>

<!-- Paginação -->
<app-pagination
  *ngIf="result && result.total > result.per_page"
  [currentPage]="result.current_page"
  [itemsPerPage]="result.per_page"
  [totalItems]="result.total"
  (pageChanged)="pageChanged($event)"
></app-pagination>
